import {
  FETCH_ALL_SKILL_CENTRES,
  FETCH_ALL_SKILL_CENTRES_SUCCESS,
  CREATE_SKILL_CENTRE,
  CREATE_SKILL_CENTRE_SUCCESS,
  ACTIVATE_SKILL_CENTRE,
  ACTIVATE_SKILL_CENTRE_SUCCESS,
  DEACTIVATE_SKILL_CENTRE,
  DEACTIVATE_SKILL_CENTRE_SUCCESS,
  EDIT_SKILL_CENTRE,
  EDIT_SKILL_CENTRE_SUCCESS,
  FETCH_TOTAL_SKILL_CENTER_DETAILS,
  FETCH_TOTAL_SKILL_CENTER_DETAILS_SUCCESS,
  RESTORE_SKILL_ACQUISITION_CENTRE_INITIAL,
  MAKE_REQUEST,
  HANDLE_API_ERROR,
  PRINT_SKILL_ACQUISITION,
  PRINT_SKILL_ACQUISITION_SUCCESS,
  EXPORT_SKILL_ACQUISITION,
  EXPORT_SKILL_ACQUISITION_SUCCESS,
  FETCH_SKILL_CENTER_SELECT,
  FETCH_SKILL_CENTER_SELECT_SUCCESS,
  EMPTY_SKILL_CENTER_SELECT,
  DOWNLOAD_SKILL_CENTER_BULK_TEMPLATE,
  DOWNLOAD_SKILL_CENTER_BULK_TEMPLATE_SUCCESS,
  ADD_BULK_SKILL_CENTER,
  ADD_BULK_SKILL_CENTER_SUCCESS
} from "../ActionTypes"


// fetching all skill centres
export const fetchAllSkillCentres = payload => ({
    type: FETCH_ALL_SKILL_CENTRES,
    payload
  })


export const fetchAllSkillCentresSuccess = payload => ({
  type: FETCH_ALL_SKILL_CENTRES_SUCCESS,
  payload
})


// creating skill centre
export const createSkillCentre = payload => ({
    type: CREATE_SKILL_CENTRE,
    payload
  })


export const createSkillCentreSuccess = payload => ({
  type: CREATE_SKILL_CENTRE_SUCCESS,
  payload
})


// activating skill centre
export const activateSkillCentre = payload => ({
    type: ACTIVATE_SKILL_CENTRE,
    payload
  })


export const activateSkillCentreSuccess = payload => ({
  type: ACTIVATE_SKILL_CENTRE_SUCCESS,
  payload
})


// deactivating skill centre
export const deactivateSkillCentre = payload => ({
    type: DEACTIVATE_SKILL_CENTRE,
    payload
  })


export const deactivateSkillCentreSuccess = payload => ({
  type: DEACTIVATE_SKILL_CENTRE_SUCCESS,
  payload
})

// edit skill centre
export const editSkillCentre = payload => ({
    type: EDIT_SKILL_CENTRE,
    payload
  })


export const editSkillCentreSuccess = payload => ({
  type: EDIT_SKILL_CENTRE_SUCCESS,
  payload
})


// fetch total skill centre details
export const fetchTotalSkillCenterDetails = payload => ({
    type: FETCH_TOTAL_SKILL_CENTER_DETAILS,
    payload
  })


export const fetchTotalSkillCenterDetailsSuccess = payload => ({
  type: FETCH_TOTAL_SKILL_CENTER_DETAILS_SUCCESS,
  payload
})



export const restoreSkillAcquisitionCentreInitial = () => ({
  type: RESTORE_SKILL_ACQUISITION_CENTRE_INITIAL,
})

export const makeRequest = () => ({
  type: MAKE_REQUEST,
})

export const handleAPIError = (message) => ({
  type: HANDLE_API_ERROR,
  message
})

export const printSkillAcquisition = () =>({
  type: PRINT_SKILL_ACQUISITION,
})

export const printSkillAcquisitionSuccess = (payload) =>({
  type: PRINT_SKILL_ACQUISITION_SUCCESS,
  payload
})

export const exportSkillAcquisition = () =>({
  type: EXPORT_SKILL_ACQUISITION
})

export const exportSkillAcquisitionSuccess = () =>({
  type: EXPORT_SKILL_ACQUISITION_SUCCESS
})

// To fetch all skill center without pagination
export const fetchSkillCenterSelect = () => ({
  type: FETCH_SKILL_CENTER_SELECT
});

export const fetchSkillCenterSelectSuccess = (payload) => ({
  type: FETCH_SKILL_CENTER_SELECT_SUCCESS,
  payload
});

export const emptySkillCenterSelect = () =>({
  type: EMPTY_SKILL_CENTER_SELECT
});

// To download skill center bulk template
export const downloadBulkSkillCenter = () =>({
  type: DOWNLOAD_SKILL_CENTER_BULK_TEMPLATE,
})
export const downloadBulkSkillCenterSuccess = (payload) =>({
  type: DOWNLOAD_SKILL_CENTER_BULK_TEMPLATE_SUCCESS,
  payload
})

// To add bulk skill center
export const addBulkSkillCenter = () =>({
  type: ADD_BULK_SKILL_CENTER,
})
export const addBulkSkillCenterSuccess = (payload) =>({
  type: ADD_BULK_SKILL_CENTER_SUCCESS,
  payload
})